import React from 'react'

export default function Card (props) {
  return (
    <div className='bg-white rounded-lg'>
      <div className='py-8 px-4 rounded-lg sm:p-10'>
        {props.children}
      </div>
    </div>
  )
}
